import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import * as Sentry from '@sentry/angular';
import { RsSentry } from '@rs-shared-lib/utils/rs-senty-init';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en-GB';
import localeDe from '@angular/common/locales/de';
import { appConfig } from '@app/app.config';

// Registering some locals to be able to use it for numbers and dates
registerLocaleData(localeFr);
registerLocaleData(localeNl);
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe);

new RsSentry({
  dsn: 'https://a97994a88234df804361f8108b7404a4@o268277.ingest.us.sentry.io/4508931625582592',
  enabled: environment.enableSentryMonitoring,
  environment: environment.environment,
  sentryReleaseName: environment.sentryReleaseName,
}).sentryInit();

Sentry.getCurrentScope().setTag('app.name', 'MOBICLEAR');
Sentry.getCurrentScope().setTag('app.environment', environment.environment);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
